import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace ProgramFields {
  export enum LegalHoldNotificationsField {
    LegalHoldNotificationsUsers = 'LegalHoldNotificationsUsers',
    LegalHoldNotificationsGroups = 'LegalHoldNotificationsGroups',
    LegalHoldNotificationsOffset = 'LegalHoldNotificationsOffset',
  }
}

class LegalHoldNotificationsConfig extends SettingsSubModule {
  @SettingsSubModule.value(ProgramFields.LegalHoldNotificationsField.LegalHoldNotificationsUsers, '')
  legalHoldNotificationsUsers: SettingValue<string>;
  @SettingsSubModule.value(ProgramFields.LegalHoldNotificationsField.LegalHoldNotificationsGroups, '')
  legalHoldNotificationsGroups: SettingValue<string>;
  @SettingsSubModule.value(ProgramFields.LegalHoldNotificationsField.LegalHoldNotificationsOffset, 3)
  legalHoldNotificationsOffset: SettingValue<number>;
}

export class ProgramModule extends SettingsModule {
  @SettingsModule.value(LegalHoldNotificationsConfig) legalHoldNotifications: LegalHoldNotificationsConfig;
}
